import { HEX, toRgb, mixWhite, darken, liftForDark, onColor } from './color'

// Variabel CSS turunan warna merek. Satu sumber untuk AppContext (yang
// memasangnya di <html>) dan pratinjau di Pengaturan (yang memasangnya hanya
// pada kotak pratinjau), supaya keduanya tidak menurunkan warna dengan cara
// berbeda.
export const BRAND_VARS = ['--program-color', '--program-color-soft', '--program-color-deep',
  '--program-color-ink', '--program-color-rgb', '--program-color-on']

/**
 * Peta variabel CSS untuk satu warna merek, atau {} bila warnanya bukan #RRGGBB
 * (pemanggil lalu membiarkan stylesheet menentukan). Variabel yang tidak
 * dihasilkan di tema tertentu (`--program-color-soft` di tema gelap, diturunkan
 * stylesheet lewat color-mix) sengaja tidak ada di peta.
 */
export function brandVars(raw, theme) {
  if (!HEX.test(raw || '')) return {}
  // Di tema gelap warna yang terlalu gelap dinaikkan terangnya agar ikon dan
  // garis beraksennya tetap terlihat (kontras ≥ 3:1 terhadap --surface).
  const base = theme === 'dark' ? liftForDark(raw, '#161C1F') : raw
  const vars = {
    '--program-color': base,
    '--program-color-deep': darken(base, 0.22),
    '--program-color-ink': darken(base, 0.58),
    // Teks di atas warna ini (tombol utama): putih, kecuali warnanya terlalu
    // terang untuk dibaca — lihat onColor().
    '--program-color-on': onColor(base),
    // Bare channels, so shadows and glows can choose their own alpha.
    '--program-color-rgb': toRgb(base).join(', '),
  }
  // Tint gelap diturunkan stylesheet lewat color-mix (index.css, blok
  // [data-theme="dark"]); tint terang yang ditulis di sini akan menimpanya.
  if (theme !== 'dark') vars['--program-color-soft'] = mixWhite(raw, 0.9)
  return vars
}
